export const GET_PROFILES = 'GET_PROFILES';
export const GET_PROFILES_SUCCESS = 'GET_PROFILES_SUCCESS';
export const GET_PROFILES_FAILURE = 'GET_PROFILES_FAILURE';
export const GET_SINGLE_PROFILE = 'GET_SINGLE_PROFILE';
export const GET_SINGLE_PROFILE_SUCCESS = 'GET_SINGLE_PROFILE_SUCCESS';
export const GET_SINGLE_PROFILE_FAILURE = 'GET_PROFILES_FAILURE';
export const SHOW_ADD_PROFILE = 'SHOW_ADD_PROFILE';
export const ADD_PROFILE = 'ADD_PROFILE';
export const ADD_PROFILE_SUCCESS = 'ADD_PROFILE_SUCCESS';
export const ADD_PROFILE_FAILURE = 'ADD_PROFILE_FAILURE';
export const OPEN_EDIT_PROFILE = 'OPEN_EDIT_PROFILE';
export const EDIT_PROFILE = 'EDIT_PROFILE';
export const EDIT_PROFILE_SUCCESS = 'EDIT_PROFILE_SUCCESS';
export const EDIT_PROFILE_FAILURE = 'EDIT_PROFILE_FAILURE';
export const VIEW_PROFILE = 'VIEW_PROFILE';
export const VIEW_PROFILE_SUCCESS = 'VIEW_PROFILE_SUCCESS';
export const VIEW_PROFILE_FAILURE = 'VIEW_PROFILE_FAILURE';
export const SET_FILTER_TEXT = 'SET_FILTER_TEXT';
export const SET_VIEW_TYPE = 'SET_VIEW_TYPE';
export const SET_SORT_KEY = 'SET_SORT_KEY';




// WEBPACK FOOTER //
// ./src/types/profile_actiontypes.js